import React from 'react'
import { useGetRolesQuery } from 'features'

export default function useRoles(_skip) {
  const { data: roles = [], isLoading: isLoadingRoles } = useGetRolesQuery(null,{skip: _skip})

  const rolesOptions = roles.map((role) => ({value: role.roleid, label: role.rolename}))

  return [roles, { isLoadingRoles, rolesOptions }]
}
